<div>
  <!-- Label -->
  <div *ngIf="label" class="block font-semibold text-gray-700 dark:text-gray-200 mb-2">
    {{ label }}
    <span *ngIf="required" class="text-red-600 ml-1">*</span>
  </div>

  <!-- Search Input (only show when no location is selected) -->
  <div *ngIf="!selectedLocation" class="w-full">
    <p-autoComplete
      [(ngModel)]="searchValue"
      [suggestions]="suggestions"
      (completeMethod)="onSearch($event)"
      (onSelect)="onLocationSelect($event)"
      (ngModelChange)="onInputChange($event)"
      field="name"
      [minLength]="3"
      [delay]="300"
      [placeholder]="placeholder"
      [disabled]="disabled"
      class="w-full"
      styleClass="w-full">

      <ng-template let-location pTemplate="item">
        <div class="flex items-start gap-3 p-3 transition-all duration-200 cursor-pointer border-b border-gray-100 dark:border-gray-700 last:border-b-0 hover:bg-gray-50 dark:hover:bg-gray-800 hover:-translate-y-px hover:shadow-md">
          <div class="flex-shrink-0 w-6 h-6 flex items-center justify-center mt-0.5">
            <i class="pi {{ getLocationTypeIcon(location.type || '') }} {{ getLocationTypeColor(location.type || '') }} text-lg"></i>
          </div>
          <div class="flex-1 min-w-0">
            <div class="font-semibold text-gray-900 dark:text-gray-50 leading-tight mb-1">
              {{ formatLocationName(location) }}
            </div>
            <div class="text-gray-600 dark:text-gray-300 text-sm leading-relaxed mb-2">
              {{ formatLocationDetails(location) }}
            </div>
          </div>
        </div>
      </ng-template>

    </p-autoComplete>
  </div>

  <!-- Selected Location Card -->
  <div *ngIf="selectedLocation" class="border-2 border-gray-200 dark:border-gray-700 rounded-xl bg-gradient-to-br from-gray-50 to-gray-100 dark:from-gray-800 dark:to-gray-900 overflow-hidden shadow-lg hover:border-gray-300 dark:hover:border-gray-600 hover:shadow-xl transition-all duration-200">
    <div class="flex items-start gap-4 p-4 bg-white dark:bg-gray-900 border-b border-gray-100 dark:border-gray-700">
      <div class="flex-shrink-0 w-10 h-10 flex items-center justify-center bg-gray-50 dark:bg-gray-800 rounded-full border-2 border-gray-200 dark:border-gray-700">
        <i class="pi {{ getLocationTypeIcon(selectedLocation.type || '') }} {{ getLocationTypeColor(selectedLocation.type || '') }} text-xl"></i>
      </div>
      <div class="flex-1 min-w-0">
        <h3 class="text-lg font-bold text-gray-900 dark:text-gray-50 mb-1 leading-tight">{{ formatLocationName(selectedLocation) }}</h3>
        <p class="text-gray-600 dark:text-gray-300 text-sm leading-relaxed m-0">{{ formatLocationDetails(selectedLocation) }}</p>
      </div>
      <button type="button"
              class="flex-shrink-0 w-8 h-8 flex items-center justify-center bg-red-100 dark:bg-red-900/50 border border-red-200 dark:border-red-800 rounded-full text-red-600 dark:text-red-400 cursor-pointer transition-all duration-200 hover:bg-red-200 dark:hover:bg-red-800 hover:border-red-300 dark:hover:border-red-700 hover:text-red-700 dark:hover:text-red-300 hover:scale-105 disabled:opacity-50 disabled:cursor-not-allowed"
              (click)="onClearSelection()"
              [disabled]="disabled">
        <i class="pi pi-times text-sm"></i>
      </button>
    </div>
  </div>
</div>
